/** @format */

import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import {
  SearchIcon,
  MenuAlt1Icon,
  XIcon,
  HomeIcon,
  TrendingUpIcon,
  ViewListIcon,
  ClockIcon,
  CheckCircleIcon,
  ThumbUpIcon,
} from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import Logo from "../../assets/Logo.png";
import { UiContext } from "../../stateManagement/context/UiContext";
import { TOGGLE_GENRE } from "../../stateManagement/variables";
import { NewspaperIcon } from "@heroicons/react/solid";
import Genre from "../genre/Genre";
import DarkModeSwitch from "./DarkModeSwitch";

export default function Navbar() {
  const [isMenuOpen, setMenuOpen] = useState(false);

  return (
    <div>
      <nav className="z-40 max-h-screen bg-gray-50 w-full h-16  sm:p-0 dark:text-white fixed top-0 dark:bg-dark-800">
        {/* Mobile View  */}
        <div className=" relative flex  flex-wrap justify-evenly ">
          {/* Mobile menu button */}
          <div className=" p-2 sm:p-1 md:p-0 bg-gray-50 absolute left-2  dark:bg-dark-800   dark:text-white inline-flex items-center justify-center  rounded-md text-gray-400  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
            <div
              onClick={() => setMenuOpen(!isMenuOpen)}
              className="  cursor-pointer p-2 md:p-4 justify-center  rounded-md text-gray-400 hover:text-black hover:bg-gray-200 dark:hover:bg-gray-600 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
            >
              <span className="sr-only">Open main menu</span>
              {isMenuOpen ? (
                <XIcon className="block  h-6 w-6" aria-hidden="true" />
              ) : (
                <MenuAlt1Icon className="block h-6 w-6" aria-hidden="true" />
              )}
            </div>
            <Link
              to="/"
              className=" dark:hover:text-gray-400 hover:text-black text-lg md:text-2xl cursor-help  "
            >
              <img
                src={Logo}
                alt="Trending Anime"
                className="block  h-10 w-36 sm:w-56 object-cover rounded-md"
              />
              {/* <div className="sm:hidden block">Trending Anime</div> */}
            </Link>
          </div>
          <div className="  pt-2 sm:pt-1 md:pt-0 w-[170px] sm:w-[330px] lg:w-[480px] absolute right-0 flex flex-wrap justify-between flex-row">
            <RenderSearchBar />
            <RenderSocialMedia />
          </div>
        </div>
        <RenderGenreMenu />
        <RenderSideMenu isMenuOpen={isMenuOpen} setMenuOpen={setMenuOpen} />
      </nav>
    </div>
  );
}

//function to render SearchBar
function RenderSearchBar() {
  return (
    <Link
      to="/search"
      className=" bg-gray-50 cursor-pointer  w-auto  ml-5  dark:bg-dark-800"
    >
      <div className="flex items-center cursor-pointer  w-full relative  justify-center p-1 rounded-md">
        <input
          disabled
          className=" hidden sm:block sm:w-[200px] lg:w-[350px]  border-2 dark:border-black border-gray-300 dark:bg-dark dark:bg-dark-100  bg-white h-10 mt-2  px-5  pl-8  rounded-full text-sm focus:outline-none"
          type="search"
          name="search"
          placeholder="Search"
        />
        <SearchIcon className="block dark:text-white text-red-500 sm:text-black h-5 ml-3 sm:m-0 top-3   sm:top-6 w-5 absolute left-3" />
      </div>
    </Link>
  );
}

//a function to render Social media icons
function RenderSocialMedia() {
  return (
    <div className="dark:bg-dark-100 bg-gray-100 w-20 h-12  sm:mt-1 mr-2 rounded-xl  px-1 pt-3  overflow-hidden order-last flex justify-between  flex-wrap flex-row">
      <a
        href="https://discord.gg/St6nhsgJt6"
        target="_blank"
        rel="noreferrer"
        className=" group cursor-pointer text-purple-500"
      >
        <i className="fab group-hover:animate-bounce  fa-discord fa-lg"></i>
      </a>
      <a
        href="https://twitter.com/Trending_Anime"
        target="_blank"
        rel="noreferrer"
        className=" group cursor-pointer text-blue-400"
      >
        <i className="fab fa-twitter fa-lg group-hover:animate-bounce"></i>
      </a>
      <a
        href="https://www.instagram.com/trendinganimeofficial/"
        target="_blank"
        rel="noreferrer"
        className=" group cursor-pointer text-red-500"
      >
        <i className="fab fa-instagram fa-lg group-hover:animate-bounce"></i>
      </a>
    </div>
  );
}

//function to render the side menu
function RenderSideMenu(props) {
  const { isMenuOpen, setMenuOpen } = props;
  return (
    <>
      <div
        onClick={() => setMenuOpen(!isMenuOpen)}
        className={
          isMenuOpen
            ? "overflow-hidden   w-full transition-opacity filter blur-md brightness-75 h-screen fixed backdrop-filter backdrop-brightness-50 backdrop-blur-sm top-0   right-0"
            : null
        }
      ></div>
      <Transition
        show={isMenuOpen}
        enterFrom="transform z-50  -translate-x-full duration-300"
        enterTo="transform  z-50 translate-x-0 duration-300 "
        leave="transition ease-in duration-300"
        leaveFrom="transform  translate-x-0"
        leaveTo="transform  -translate-x-full duration-300"
      >
        <div>
          <div className="z-50 rounded-lg p-1  dark:bg-dark-800 fixed left-0 top-0 h-screen bg-gray-50 w-[250px] ">
            <div className="relative h-screen">
              <div className=" bg-gray-50 pb-4   dark:bg-dark-800   dark:text-white inline-flex items-center justify-center  rounded-md  text-gray-400  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                <div
                  onClick={() => setMenuOpen(!isMenuOpen)}
                  className="  cursor-pointer p-2 md:p-4 justify-center  rounded-md text-gray-400  hover:text-black hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                >
                  <span className="sr-only">Open main menu</span>
                  {isMenuOpen ? (
                    <XIcon className="block  h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuAlt1Icon
                      className="block h-6 w-6"
                      aria-hidden="true"
                    />
                  )}
                </div>
                <Link
                  to="/"
                  className="dark:hover:text-gray-50 font-windSong dark:text-gray-600 text-xl hover:text-black  p-1 cursor-pointer "
                >
                  <img
                    src={Logo}
                    alt="Trending Anime"
                    className="block  h-10 w-36 sm:w-56 object-cover rounded-md"
                  />
                </Link>
              </div>
              <div className="flex flex-wrap gap-2 font-montserrat justify-between flex-col">
                {/* Nav Items */}
                <div className="   pl-5 h-12  pt-2 font-semibold hover:shadow duration-200  cursor-pointer  dark:bg-dark-800 dark:hover:bg-gray-800  bg-gray-50">
                  <Link
                    to="/"
                    className="w-[180px] flex pt-1 gap-2 flex-row h-8"
                  >
                    <HomeIcon aria-hidden="true" className="h-6 w-6" />{" "}
                    <p className="h-6 inline-block">Home</p>
                  </Link>
                </div>

                <div className="   pl-5 h-12  pt-2 font-semibold hover:shadow duration-200  cursor-pointer  dark:bg-dark-800 dark:hover:bg-gray-800  bg-gray-50">
                  <Link
                    to="/title/Anime List"
                    className="w-[180px] flex pt-1 gap-2 flex-row h-8"
                  >
                    <ViewListIcon aria-hidden="true" className="h-6 w-6" />{" "}
                    <p className="h-6 inline-block">Anime List</p>
                  </Link>
                </div>

                <div className="   pl-5 h-12  pt-2 font-semibold hover:shadow duration-200  cursor-pointer dark:bg-dark-800 dark:hover:bg-gray-800  bg-gray-50">
                  <Link
                    to="/title/Trending"
                    className="w-[180px] flex pt-1 gap-2 flex-row h-8"
                  >
                    <TrendingUpIcon aria-hidden="true" className="h-6 w-6" />{" "}
                    <p className="h-6 inline-block">Trending</p>
                  </Link>
                </div>

                <Link
                  to="/title/Up Coming"
                  className="pl-5 h-12  pt-2 font-semibold hover:shadow duration-200  cursor-pointer dark:bg-dark-800 dark:hover:bg-gray-800  bg-gray-50"
                >
                  <div className="w-[180px] flex pt-1 gap-2 flex-row h-8">
                    <ClockIcon aria-hidden="true" className="h-6 w-6" />{" "}
                    <p className="h-6 inline-block">Up Coming</p>
                  </div>
                </Link>

                <div className="   pl-5 h-12  pt-2 font-semibold hover:shadow duration-200  cursor-pointer dark:bg-dark-800 dark:hover:bg-gray-800   bg-gray-50">
                  <Link
                    to="/title/Finished"
                    className="w-[180px] flex pt-1 gap-2 flex-row h-8"
                  >
                    <CheckCircleIcon aria-hidden="true" className="h-6 w-6" />{" "}
                    <p className="h-6 inline-block">Finished</p>
                  </Link>
                </div>

                <div className="   pl-5 h-12  pt-2 font-semibold hover:shadow duration-200  cursor-pointer dark:bg-dark-800 dark:hover:bg-gray-800  bg-gray-50">
                  <Link to="/title/Recommendation">
                    <div className="w-[180px] flex pt-1 gap-2 flex-row h-8">
                      <ThumbUpIcon aria-hidden="true" className="h-6 w-6" />{" "}
                      <p className="h-6 inline-block">Recommended</p>
                    </div>
                  </Link>
                </div>

                <div className="   pl-5 py-6  pt-2 font-semibold hover:shadow duration-200  cursor-pointer dark:bg-dark-800 dark:hover:bg-gray-800  bg-gray-50">
                  <Link
                    to="/news/anime"
                    className="w-[180px] flex pt-1 gap-2 flex-row h-8"
                  >
                    <NewspaperIcon aria-hidden="true" className="h-6 w-6" />{" "}
                    <p className="h-6 inline-block">Anime/Manga News</p>
                  </Link>
                </div>

                {/* End of nav Items */}
                <div className="w-auto z-40 m-auto  mt-5 block">
                  <DarkModeSwitch />
                </div>
              </div>

              {/* SOcial Links */}

              <div className=" pt-8 px-5 absolute bottom-0  w-[240px]   rounded-lg h-36">
                <p className="text-lg font-simonetta italic">Find us at</p>
                <div className="w-full mt-3 flex flex-row gap-3 m-auto flex-wrap ">
                  <a
                    href="https://discord.gg/St6nhsgJt6"
                    target="_blank"
                    rel="noreferrer"
                    className=" group cursor-pointer text-purple-500"
                  >
                    <i className="fab group-hover:animate-bounce  fa-discord fa-lg"></i>
                  </a>

                  <a
                    href="https://www.instagram.com/trendinganimeofficial/"
                    target="_blank"
                    rel="noreferrer"
                    className=" group cursor-pointer text-red-500"
                  >
                    <i className="fab fa-instagram fa-lg group-hover:animate-bounce"></i>
                  </a>

                  <div className=" group cursor-pointer text-blue-600">
                    <i className="fab fa-facebook fa-lg group-hover:animate-bounce "></i>
                  </div>

                  <a
                    href="https://twitter.com/Trending_Anime"
                    target="_blank"
                    rel="noreferrer"
                    className=" group cursor-pointer text-blue-400"
                  >
                    <i className="fab fa-twitter fa-lg group-hover:animate-bounce"></i>
                  </a>

                  <a
                    href="https://www.reddit.com/r/trendinganimeofficial/"
                    target="_blank"
                    rel="noreferrer"
                    className=" group cursor-pointer text-red-500"
                  >
                    <i className="fab fa-reddit fa-lg group-hover:animate-bounce"></i>
                  </a>

                  <a
                    href="https://ttttt.me/TrendingAnimeOfficial"
                    target="_blank"
                    rel="noreferrer"
                    className=" group cursor-pointer text-blue-500"
                  >
                    <i className="fab fa-telegram fa-lg group-hover:animate-bounce"></i>
                  </a>

                  <div className=" group cursor-pointer text-red-500">
                    <i className="fab fa-quora fa-lg group-hover:animate-bounce"></i>
                  </div>
                  <a
                    href="https://in.pinterest.com/trendinganimeofficial/"
                    target="_blank"
                    rel="noreferrer"
                    className=" group cursor-pointer text-red-500"
                  >
                    <i className="fab fa-pinterest fa-lg group-hover:animate-bounce"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </>
  );
}

// function to render Genre Menu
function RenderGenreMenu() {
  const { uiState, dispatch } = React.useContext(UiContext);
  const { isGenreOpen } = uiState;
  return (
    <>
      <div
        onClick={() => dispatch({ type: TOGGLE_GENRE })}
        className={
          isGenreOpen
            ? "overflow-hidden z-10  w-full transition-opacity filter blur-md brightness-75 h-screen fixed backdrop-filter backdrop-brightness-50 backdrop-blur-sm top-0   right-0"
            : null
        }
      ></div>
      <Transition
        show={isGenreOpen}
        enterFrom="transform  -translate-x-full duration-300"
        enterTo="transform  z-50 translate-x-0 duration-300 "
        leave="transition  ease-in duration-300"
        leaveFrom="transform   translate-x-0"
        leaveTo="transform   -translate-x-full duration-300"
      >
        <Genre />
      </Transition>
    </>
  );
}
